/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 11th 2023, 12:39:08 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { withAccessCheck } from "authorization/hoc";
import { useGlobalScope } from "core/providers";
import { getDefaultAITaskInstruction } from "lib/factories";
import { AITaskInstruction } from "lib/schemas";
import { useAIWorkersAPI } from "service-builder/services/AIWorkersAPI";
import { OSAPIForm } from "ui-widgets";
import { TextFormInput, TextAreaFormInput } from "ui-widgets/forms";

type UseAITaskInstructionsAPIFormFunction = ReturnType<typeof useAIWorkersAPI>["useAITaskInstructionsAPIForm"];

type AITaskInstructionFormProps = Parameters<UseAITaskInstructionsAPIFormFunction>[0] & {};

export const AITaskInstructionForm = withAccessCheck(
  { resourceId: "configureAIWorkers" },
  ({
    aiInstructionsDefaultValues,
    aiInstructionsFetchId,
    updateAiInstructionsFromAPICallback,
  }: AITaskInstructionFormProps) => {
    const {
      globalState: { selectedOrganization },
    } = useGlobalScope();
    const { useAITaskInstructionsAPIForm } = useAIWorkersAPI();
    const useAPIFormReturn = useAITaskInstructionsAPIForm({
      aiInstructionsDefaultValues: aiInstructionsDefaultValues || getDefaultAITaskInstruction(selectedOrganization),
      aiInstructionsFetchId,
      updateAiInstructionsFromAPICallback,
    });
    return (
      <OSAPIForm useAPIFormReturn={useAPIFormReturn}>
        <TextFormInput<AITaskInstruction> schema_field_key="name" label="Name" />
        <TextAreaFormInput<AITaskInstruction> schema_field_key="prompt" label="Instructions" />
        <TextAreaFormInput<AITaskInstruction> schema_field_key="input" label="Input" />
      </OSAPIForm>
    );
  }
);
